/** =========================================================
 * Order tasks controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-order-tasks')
    .controller('OrderTasksController', OrderTasksController);

  OrderTasksController.$inject = [
    '$rootScope',
    '$scope',
    '$api',
    '$state',
    '$stateParams',
    '$translate',
    '$q',
    '$window',
    '$location',
    'ngDialog',
    'MainPreloader'
  ];

  function OrderTasksController(
    $rootScope,
    $scope,
    $api,
    $state,
    $stateParams,
    $translate,
    $q,
    $window,
    $location,
    ngDialog,
    MainPreloader
  ) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page order tasks',
        data: {
          filters: $stateParams.filters
        }
      });

      var filters = function () {
        if (typeof $location.search().id !== 'undefined') {
          return [{
            'attr': 'where',
            'name': '',
            'value': [
              ['id', '=', $location.search().id]
            ]
          }];
        }

        return angular.copy($stateParams.filters);
      };

      function setDeadline(item, orders) {
        try {
          var definedOrder = orders.filter(function (order) {
            return order.id === item.order_id;
          })[0];

          item.deadline = definedOrder.deadline;
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function getDeadlineClass(item) {
        var nowMoment = moment();
        var deadlineMoment = moment(item.deadline);

        if (item.status === 'finished') {
          return 'text-white';
        }

        if (nowMoment.isAfter(deadlineMoment)) {
          return 'text-danger';
        }

        if (nowMoment.add(1, 'day').isAfter(deadlineMoment)) {
          return 'text-warning';
        }

        return 'text-muted';
      }

      vm.tableConfig = {
        model: 'order_task',
        getDataParams: {
          order: {
            created_at: 'desc'
          },
          with: [{
            order_task_type: ['id', 'slug', 'name']
          }, {
            start_user: ['id', 'name']
          }, {
            end_user: ['id', 'name']
          }, 'order.order_files&customer&user', 'referer', 'reference'],
          whereHas: [
            ['order', 'archived', '=', false]
          ]
        },
        filters: filters(),
        resources: ['user', 'order', 'order_task_type', 'order_task'],
        resourceUpdateConditions: {
          user: {
            watch: 'order_task_type_id',
            selected: function (item) {
              return [item.start_user_id, item.end_user_id];
            },
            params: function (item) {
              return {
                order_task_type_id: item.order_task_type_id,
                active: true
              };
            }
          },
          order: {
            selected: function (item) {
              return [item.order_id];
            },
            params: function () {
              return {
                selectOptions: ['id', 'uid', 'name', 'deadline'],
                archived: false
              };
            }
          },
          order_task_type: {
            params: function () {
              return {
                selectOptions: ['id', 'slug', 'name']
              };
            }
          },
          order_task: {
            watch: 'order_id',
            params: function (item) {
              return {
                referers: true,
                order_task_id: item.id,
                order_id: item.order_id,
                selectOptions: ['id', 'order_id', 'referer_id', 'order_task_type_id']
              };
            }
          }
        },
        helpers: {
          setDeadline: setDeadline
        },
        fields: [{
          title: 'Status',
          key: 'status',
          customType: 'html',
          value: function (item) {
            return '<span class="label label-' + item.status + '">' + $translate.instant($rootScope.appConfig.types.status_types[item.status]) + '</span>';
          },
          sort: true
        }, {
          title: 'Type',
          key: 'order_task_type_id',
          value: function (item) {
            return '<span title="' + item.order_task_type.cname + '">' + item.order_task_type.slug + '</span>';
          },
          customType: 'html',
          order: true,
          filter: {
            model: 'order_task_type',
            name: 'cname',
            action: function (value) {
              try {
                var filterFoundIndex = -1;

                vm.tableConfig.filters.forEach(function (currentFilter, index) {
                  if (currentFilter.value.length !== 0
                    && currentFilter.value[0][0] === 'order_task_type_id'
                  ) {
                    filterFoundIndex = index;
                  }
                });

                if (value) {
                  var filter = {
                    name: $translate.instant('Order task type') + ': ' + value.cname,
                    attr: 'where',
                    value: [
                      ['order_task_type_id', '=', value.id]
                    ]
                  };

                  if (filterFoundIndex > -1) {
                    vm.tableConfig.filters[filterFoundIndex] = filter;
                  } else {
                    vm.tableConfig.filters.push(filter);
                  }
                } else if (!value && filterFoundIndex > -1) {
                  vm.tableConfig.filters = vm.tableConfig.filters.splice(filterFoundIndex + 1);
                }

                vm.tableConfig.getData();
              } catch (error) {
                Raven.captureException(error);
              }
            }
          }
        }, {
          title: 'Date created',
          key: 'created_at',
          value: function (item) {
            return '<div class="dual-cell"><div class="text-nowrap">' + moment(item.created_at).format($rootScope.appConfig.dateTimeFormat) + '</div><div class="text-muted" title="' + item.order.user.name + '"><em class="icon-user"></em> ' + $rootScope.helpers.shortenText(item.order.user.name, 12) + '</div></div>';
          },
          customType: 'html',
          order: true
        }, {
          title: 'Deadline',
          key: 'deadline',
          value: function (item) {
            return '<div class="dual-cell"><div class="text-nowrap">' + moment(item.deadline).format($rootScope.appConfig.dateTimeFormat) + '</div><div class="' + getDeadlineClass(item) + '"><em class="icon-clock"></em> ' + moment(item.deadline).fromNow() + '</div></div>';
          },
          customType: 'html',
          order: true
        }, {
          title: 'Order',
          key: 'order_id',
          value: function (item) {
            return '<div class="dual-cell"><div><span class="text-bold">' + item.order.uid + '</span>: ' + item.order.name + '</div><div class="text-muted"><em class="icon-briefcase"></em> ' + item.order.customer.name + '</div></div>';
          },
          customType: 'html',
          order: true
        }, {
          title: 'User',
          key: 'start_user_id',
          value: function (item) {
            if (item.status === 'finished') {
              return item.end_user.name;
            } else if (item.start_user_id !== null) {
              return item.start_user.name;
            }

            return '';
          },
          order: true
        }],
        add: {
          permission: $rootScope.helpers.hasPermissionTo('order edit'),
          template: 'app/views/dialogs/item-order-task.html',
          before: function (item, scope) {
            return new Promise(function (resolve, reject) {
              try {
                if ($stateParams.filters.length !== 0 && $stateParams.filters[0].value.length !== 0) {
                  var orders = scope.resources.order.filter(function (order) {
                    return order.id === $stateParams.filters[0].value[0][2];
                  });

                  if (orders.length === 1) {
                    item.order_id = orders[0].id;
                  }
                }

                resolve();
              } catch (error) {
                Raven.captureException(error);

                reject(error);
              }
            });
          }
        },
        edit: {
          permission: $rootScope.helpers.hasPermissionTo('order edit'),
          template: 'app/views/dialogs/item-order-task.html',
          wide: true,
          except: [
            'status',
            'order_task_type',
            'order',
            'start_user',
            'end_user',
            'referer',
            'reference'
          ]
        },
        delete: {},
        customButtons: [{
          permission: $rootScope.helpers.hasPermissionTo('order_task view'),
          title: 'Custom task info',
          icon: 'icon-info',
          class: 'btn-default',
          visible: function (item) {
            try {
              return item.order.order_files.length !== 0 || item.order.description || item.description;
            } catch (error) {
              Raven.captureException(error);
            }

            return false;
          },
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.item = angular.copy(item);
              dialogScope.config = $rootScope.config;

              MainPreloader.show();

              $q.all([
                $api.getAll({
                  model: 'order_file',
                  data: {
                    getAttrs: ['mime'],
                    where: [
                      ['order_id', '=', item.order_id]
                    ]
                  }
                }),
                $api.getOne({
                  id: item.order_id,
                  model: 'order',
                  data: {
                    getAttrs: ['arranged_order_tasks']
                  }
                })
              ]).then(function (response) {
                MainPreloader.hide();

                dialogScope.item.order_files = response[0].data.items;
                dialogScope.item.arranged_order_tasks = response[1].data.arranged_order_tasks;

                ngDialog.openConfirm({
                  template: 'app/views/dialogs/order-task-info.html',
                  scope: dialogScope
                });
              }, MainPreloader.hide);
            } catch (error) {
              MainPreloader.hide();

              Raven.captureException(error);
            }
          }
        }, {
          title: 'Order label',
          icon: 'icon-tag',
          class: 'btn-default',
          permission: $rootScope.helpers.hasPermissionTo('order view'),
          action: function (item) {
            try {
              var printers = $rootScope.appConfig.printers || [];

              if (printers.length > 0) {
                MainPreloader.show();

                var printerId = $window.localStorage.getItem('printerId') || printers[0].id;

                $api.post({
                  path: '/api/print_order_label',
                  data: {
                    order_id: item.order_id,
                    printer_id: printerId
                  },
                  notifications: {
                    success: 'Printed successfully',
                    error: 'Unable to print'
                  }
                }).then(MainPreloader.hide, MainPreloader.hide);
              }
            } catch (error) {
              MainPreloader.hide();

              Raven.captureException(error);
            }
          }
        }, {
          permission: $rootScope.helpers.hasPermissionTo('order_task edit'),
          title: 'Comment',
          icon: 'fa fa-comment-o',
          class: function (item) {
            return item.comment ? 'btn-primary' : 'btn-default';
          },
          visible: function (item) {
            try {
              return item.start === null || (item.start !== null && item.start_user_id === $rootScope.appConfig.user.id) || (item.end !== null && item.end_user_id === $rootScope.appConfig.user.id);
            } catch (error) {
              Raven.captureException(error);
            }

            return false;
          },
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.item = angular.copy(item);

              ngDialog.openConfirm({
                template: 'app/views/dialogs/order-task-comment.html',
                scope: dialogScope,
                closeByDocument: false
              }).then(function () {
                MainPreloader.show();

                $api.update({
                  model: 'order_task',
                  data: dialogScope.item,
                  only: ['comment', 'has_issue']
                }).then(MainPreloader.hide, MainPreloader.hide);
              });
            } catch (error) {
              MainPreloader.hide();

              Raven.captureException(error);
            }
          }
        }, {
          permission: $rootScope.helpers.hasPermissionTo('order_task edit'),
          title: 'Cancel finish',
          icon: 'icon-reload',
          class: 'btn-default',
          visible: function (item) {
            try {
              return item.end_user_id === $rootScope.appConfig.user.id && (item.reference === null || (item.reference !== null && item.reference.start === null));
            } catch (error) {
              Raven.captureException(error);
            }

            return false;
          },
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.message = $translate.instant('Do you want to cancel finish?') + ': ' + item.order_task_type.cname;
              dialogScope.title = item.order.cname;

              ngDialog.openConfirm({
                template: 'app/views/dialogs/confirm.html',
                scope: dialogScope
              }).then(function () {
                MainPreloader.show();

                $api.update({
                  model: 'order_task',
                  data: {
                    id: item.id,
                    end_user_id: null,
                    end: null
                  }
                }).then(MainPreloader.hide, MainPreloader.hide);
              });
            } catch (error) {
              MainPreloader.hide();

              Raven.captureException(error);
            }
          }
        }, {
          permission: $rootScope.helpers.hasPermissionTo('order_task edit'),
          title: 'Start',
          icon: 'icon-control-play',
          class: 'btn-default',
          visible: function (item) {
            try {
              return item.start === null && item.end === null && (item.referer === null || (item.referer && item.referer.status === 'finished'));
            } catch (error) {
              Raven.captureException(error);
            }

            return false;
          },
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.message = $translate.instant('Do you want to start?') + ': ' + item.order_task_type.cname;
              dialogScope.title = item.order.cname;

              ngDialog.openConfirm({
                template: 'app/views/dialogs/confirm.html',
                scope: dialogScope
              }).then(function () {
                MainPreloader.show();

                $api.update({
                  model: 'order_task',
                  data: {
                    id: item.id,
                    start: true
                  }
                }).then(MainPreloader.hide, MainPreloader.hide);
              });
            } catch (error) {
              MainPreloader.hide();

              Raven.captureException(error);
            }
          }
        }, {
          permission: $rootScope.helpers.hasPermissionTo('order_task edit'),
          title: 'Finish',
          icon: 'icon-like',
          class: 'btn-success',
          visible: function (item) {
            try {
              return item.start !== null && item.end === null && item.start_user_id === $rootScope.appConfig.user.id;
            } catch (error) {
              Raven.captureException(error);
            }

            return false;
          },
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.item = angular.copy(item);

              ngDialog.openConfirm({
                template: 'app/views/dialogs/order-task-finish.html',
                scope: dialogScope
              }).then(function () {
                MainPreloader.show();

                $api.update({
                  model: 'order_task',
                  data: {
                    id: item.id,
                    end: true,
                    comment: dialogScope.item.comment,
                    has_issue: false
                  }
                }).then(MainPreloader.hide, MainPreloader.hide);
              });
            } catch (error) {
              MainPreloader.hide();

              Raven.captureException(error);
            }
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
